import {
  handleCallSessionUpdate,
  handleCommunicationLogsUpdate,
  handleSmsMessageEvent,
} from "@/helpers/websockets/communication/handlers";

export const COMMUNICATION_LOGS_EVENT = ".communication_logs" as const;
export const COMMUNICATION_LOGS_INDEXED_EVENT =
  ".communication_log_indexed" as const;
export const CALL_SESSIONS_EVENT = ".call_session" as const;
export const SMS_MESSAGE_EVENT = ".sms_message" as const;

export const COMMUNICATION_LOGS_EVENT_HANDLERS = {
  [COMMUNICATION_LOGS_EVENT]: handleCommunicationLogsUpdate,
  [COMMUNICATION_LOGS_INDEXED_EVENT]: handleCommunicationLogsUpdate,
};

export const CALL_EVENT_HANDLERS = {
  [CALL_SESSIONS_EVENT]: handleCallSessionUpdate,
};

export const SMS_EVENT_HANDLERS = {
  [SMS_MESSAGE_EVENT]: handleSmsMessageEvent,
};
